import { Layout } from 'antd';
import * as clone from 'clone';
import * as React from 'react';
import { Icon as FaIcon } from 'react-fa';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as Immutable from 'seamless-immutable';
import Menu from '../../components/uielements/menu';
import Scrollbars from '../../components/utility/customScrollBar';
import IntlMessages from '../../components/utility/intlMessages';
import Logo from '../../components/utility/logo';
import AppConfig from '../../config/AppConfig';
import AppRedux from '../../redux/app/appRedux';
import LanguageSwitcherRedux from '../../redux/languageSwitcher/languageSwitcherRedux';
import { getCurrentTheme } from '../ThemeSwitcher/config';
import SidebarWrapper from './sidebar.style';
import { getSagaWAPUrl } from '../../helpers/utility';
import { getCurrentLanguage } from '../LanguageSwitcher/config';
import basicStyle from '../../config/basicStyle';

const SubMenu = Menu.SubMenu;
const { Sider } = Layout;
const tag = '[SIDEBAR]';

class Sidebar extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            collapsed: false,
            openDrawer: false,
            openKeys: [],
            current: [],
            view: '',
            height: window.innerHeight,
            userName: null,
            branchId: null,
            password: null,
            isAdmin: false,
            isAllowViewContact: true
        };
    }

    public componentWillReceiveProps(newProps) {
        const newState = {
            collapsed: newProps.collapsed,
            openDrawer: newProps.openDrawer,
            openKeys: newProps.openKeys,
            view: newProps.view,
            current: newProps.current,
            height: newProps.height ? newProps.height : this.props.height,
            userName: newProps.userName,
            branchId: newProps.branchId,
            password: newProps.password,
            isAdmin: newProps.isAdmin,
            isAllowViewContact: newProps.isAllowViewContact,
        };
        // console.log(' ------- >>> Setting state to : ', newState);
        this.setState(newState);
    }

    public handleClick(e) {
        this.props.changeCurrent([e.key]);

        switch (e.key) {
            case 'langEn': {
                this.props.changeLanguage('en');
                break;
            }
            case 'langTh': {
                this.props.changeLanguage('th');
                break;
            }
            case 'langIs': {
                this.props.changeLanguage('is');
                break;
            }
            default: {
                break;
            }

        }


        if (this.state.view === 'MobileView') {
            setTimeout(() => {
                this.props.toggleCollapsed();
                this.props.toggleOpenDrawer();
            }, 100);
        }
    }

    public onOpenChange(newOpenKeys) {
        const { changeOpenKeys } = this.props;
        const latestOpenKey = newOpenKeys.find(
            key => !(this.state.openKeys.indexOf(key) > -1)
        );
        const latestCloseKey = this.state.openKeys.find(
            key => !(newOpenKeys.indexOf(key) > -1)
        );
        let nextOpenKeys = [];
        if (latestOpenKey) {
            nextOpenKeys = this.getAncestorKeys(latestOpenKey).concat(
                latestOpenKey
            );
        }
        if (latestCloseKey) {
            nextOpenKeys = this.getAncestorKeys(latestCloseKey);
        }
        // console.log(
        //     ' ------- >>> ATTEMPTING TO CHANGE OPNE KEY TO :',
        //     nextOpenKeys
        // );
        changeOpenKeys(nextOpenKeys);
    }

    public getAncestorKeys = key => {
        const map = {
            sub3: ['sub2']
        };
        return map[key] || [];
    }

    public replaceLanguageInPath(newLanguague) {
        const path = window.location.pathname.split('/');
        path[2] = newLanguague;
        const newPath = path.join('/');
        return newPath;
    }

    public renderLanguageMenus(submenuStyle, submenuColor) {
        const menuItems = [];

        AppConfig.enabledLanguages.map(
            o => {
                const lang = getCurrentLanguage(o);
                const localelang = `language.${lang.locale}.sidebar`;
                menuItems.push(<Menu.Item
                    key={'lang' + lang.locale[0].toUpperCase() + lang.locale.substring(1)}>
                    <span
                        className='isoMenuHolder'
                        style={submenuColor}>
                        <img src={lang.icon} style={{
                            width: '25px',
                            marginRight: `${basicStyle.gutter}px`
                        }} />
                        <span className='nav-text'>
                            <IntlMessages id={localelang} />
                        </span>
                    </span>
                </Menu.Item>);
            }
        );

        return menuItems;
    }

    public render() {
        const { url, toggleOpenDrawer } = this.props;
        const customizedTheme = getCurrentTheme(
            'sidebarTheme',
            AppConfig.themeConfig.theme
        );
        const collapsed =
            clone(this.state.collapsed, undefined, undefined, undefined, undefined) && !clone(this.state.openDrawer, undefined, undefined, undefined, undefined);
        const { openDrawer } = this.state;
        const mode = collapsed === true ? 'vertical' : 'inline';
        const onMouseEnter = event => {
            if (openDrawer === false) {
                toggleOpenDrawer();
            }
            return;
        };
        const onMouseLeave = () => {
            if (openDrawer === true) {
                toggleOpenDrawer();
            }
            return;
        };
        const scrollheight = this.state.height;
        const styling = {
            backgroundColor: customizedTheme.backgroundColor
        };
        const submenuStyle = {
            backgroundColor: 'rgba(0,0,0,0.3)',
            color: customizedTheme.textColor
        };
        const submenuColor = {
            color: customizedTheme.textColor
        };

        return <SidebarWrapper>
            <Sider
                trigger={null}
                collapsible={true}
                collapsed={collapsed}
                width={240}
                className='isomorphicSidebar'
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                style={styling}>
                <Logo collapsed={collapsed} />
                <Scrollbars
                    className={'box'}
                    style={{
                        height: scrollheight - 70
                    }}>
                    <Menu
                        onClick={this.handleClick.bind(this)}
                        theme='dark'
                        mode={mode}
                        openKeys={
                            collapsed
                                ? []
                                : Immutable.asMutable(this.state.openKeys)
                        }
                        selectedKeys={Immutable.asMutable(
                            this.state.current
                        )}
                        onOpenChange={this.onOpenChange.bind(this)}
                        className='isoDashboardMenu'>

                        <Menu.Item key='projectList'>
                            <Link to={`${url}/projects`}>
                                <span className='isoMenuHolder' style={submenuColor}>
                                    <FaIcon className='icon' name='list-ul' />
                                    <span className='nav-text'>
                                        <IntlMessages id='sidebar.projectList' />
                                    </span>
                                </span>
                            </Link>
                        </Menu.Item>
                        <Menu.Item key='propertyList'>
                            <Link
                                className='isoMenuHolder'
                                style={submenuColor}
                                to={`${url}/properties`}
                            >
                                <FaIcon className='icon' name='building' />
                                <span className='nav-text'>
                                    <IntlMessages id='sidebar.propertyList' />
                                </span>
                            </Link>
                        </Menu.Item>
                        {
                            this.state.isAllowViewContact ? 
                            <SubMenu
                                key='account'
                                title={
                                    <span
                                        className='isoMenuHolder'
                                        style={submenuColor}>
                                        <FaIcon className='icon' name='address-book' />
                                        <span className='nav-text'>
                                            <IntlMessages id='sidebar.account' />
                                        </span>
                                    </span>
                                }>
                                    
                                    <Menu.Item key='contact'>
                                        <Link
                                            className='isoMenuHolder'
                                            style={submenuColor}
                                            to={`${url}/account/contact`}
                                        >
                                            <FaIcon className='icon' name='user' />
                                            <span className='nav-text'>
                                                <IntlMessages id='sidebar.contacts' />
                                            </span>
                                        </Link>
                                    </Menu.Item>
                                    <Menu.Item key='enquiry'>
                                        <Link
                                            className='isoMenuHolder'
                                            style={submenuColor}
                                            to={`${url}/account/enquiry`}
                                        >
                                            <FaIcon className='icon' name='envelope-open' />
                                            <span className='nav-text'>
                                                <IntlMessages id='sidebar.enquiry' />
                                            </span>
                                        </Link>
                                    </Menu.Item>
                                    <Menu.Item key='lead'>
                                        <Link
                                            className='isoMenuHolder'
                                            style={submenuColor}
                                            to={`${url}/account/lead`}
                                        >
                                            <FaIcon className='icon' name='filter' />
                                            <span className='nav-text'>
                                                <IntlMessages id='sidebar.lead' />
                                            </span>
                                        </Link>
                                    </Menu.Item>
                            </SubMenu>
                            : null
                        }

                        <Menu.Item key='calendar'>
                            <Link to={`${url}/calendar`}>
                                <span className='isoMenuHolder' style={submenuColor}>
                                    <FaIcon className='icon' name='calendar' />
                                    <span className='nav-text'>
                                        <IntlMessages id='sidebar.calendar' />
                                    </span>
                                </span>
                            </Link>
                        </Menu.Item>
                        {/* <Menu.Item key='setting'>
                            <Link to={`${url}/setting`}>
                                <span className='isoMenuHolder' style={submenuColor}>
                                    <FaIcon className='icon' name='wrench' />
                                    <span className='nav-text'>
                                        <IntlMessages id='sidebar.settings' />
                                    </span>
                                </span>
                            </Link>
                        </Menu.Item> */}
                        <SubMenu
                            key='setting'
                            title={
                                <span
                                    className='isoMenuHolder'
                                    style={submenuColor}>
                                    <FaIcon className='icon' name='wrench' />
                                    <span className='nav-text'>
                                        <IntlMessages id='sidebar.settings' />
                                    </span>
                                </span>
                            }>
                            <Menu.Item key='employee'>
                                <Link
                                    className='isoMenuHolder'
                                    style={submenuColor}
                                    to={`${url}/setting/employee`}
                                >
                                    <FaIcon className='icon fa-user-circle' />
                                    <span className='nav-text'>
                                        <IntlMessages id='setting.menu.employee.status' />
                                    </span>
                                </Link>
                            </Menu.Item>
                            <Menu.Item key='contactOrEnquiry'>
                                <Link
                                    className='isoMenuHolder'
                                    style={submenuColor}
                                    to={`${url}/setting/contactOrEnquiry`}
                                >
                                    <FaIcon className='icon fa-comments' />
                                    <span className='nav-text'>
                                        <IntlMessages id='setting.menu.enquiry.status' />
                                    </span>
                                </Link>
                            </Menu.Item>
                            <Menu.Item key='office'>
                                <Link
                                    className='isoMenuHolder'
                                    style={submenuColor}
                                    to={`${url}/setting/office`}
                                >
                                    <FaIcon className='icon fa-sitemap' />
                                    <span className='nav-text'>
                                        <IntlMessages id='setting.menu.office.status' />
                                    </span>
                                </Link>
                            </Menu.Item>
                            <Menu.Item key='propertyOrProject'>
                                <Link
                                    className='isoMenuHolder'
                                    style={submenuColor}
                                    to={`${url}/setting/propertyOrProject`}
                                >
                                    <FaIcon className='icon fa-cogs' />
                                    <span className='nav-text'>
                                        <IntlMessages id='setting.menu.propertyAndProject.status' />
                                    </span>
                                </Link>
                            </Menu.Item>
                        </SubMenu>

                        <SubMenu
                            key='reports'
                            title={
                                <span
                                    className='isoMenuHolder'
                                    style={submenuColor}>
                                    <i className='fa fa-file-text'></i>
                                    <span className='nav-text'>
                                        <IntlMessages id='reports.label' />
                                    </span>
                                </span>
                            }>
                            <Menu.Item key='saleReport'>
                                <Link
                                    className='isoMenuHolder'
                                    style={submenuColor}
                                    to={`${url}/saleReport`}
                                >
                                     <FaIcon className='icon' name='line-chart' />
                                    <span className='nav-text'>
                                    <IntlMessages id='sidebar.salesReport' />
                                    </span>
                                </Link>
                            </Menu.Item>
                            <Menu.Item key='propertyReport'>
                                <Link
                                    className='isoMenuHolder'
                                    style={submenuColor}
                                    to={`${url}/propertyReport`}
                                >
                                    <FaIcon className='icon' name='file-excel-o' />
                                    <span className='nav-text'>
                                        <IntlMessages id='sidebar.PropertyStatusReport' />
                                    </span>
                                </Link>
                            </Menu.Item>
                        </SubMenu>
                        <SubMenu
                            key='languages'
                            title={
                                <span
                                    className='isoMenuHolder'
                                    style={submenuColor}>
                                    <FaIcon className='icon' name='language' />
                                    <span className='nav-text'>
                                        <IntlMessages id='languageSwitcher.label' />
                                    </span>
                                </span>
                            }>
                            {this.renderLanguageMenus(submenuStyle, submenuColor)}
                        </SubMenu>

                    </Menu>
                </Scrollbars>
            </Sider>
        </SidebarWrapper>;
    }
}

const mapStateToProps = (state) => {
    return {
        collapsed: state.App.collapsed,
        openDrawer: state.App.openDrawer,
        openKeys: state.App.openKeys,
        view: state.App.view,
        current: state.App.current,
        height: state.App.height,
        userName: state.SagaAuth.username,
        branchId: state.SagaAuth.userProfileResponse.branchId,
        password: state.SagaAuth.password,
        isAdmin: state.SagaAuth.userProfileResponse.isAdmin,
        isAllowViewContact: state.SagaAuth.userProfileResponse.isAllowViewContact,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        toggleOpenDrawer: () => dispatch(AppRedux.collapseOpenDrawer()),
        changeOpenKeys: openKeys => dispatch(AppRedux.changeOpenKeys(openKeys)),
        changeCurrent: current => dispatch(AppRedux.changeCurrent(current)),
        toggleCollapsed: () => dispatch(AppRedux.collapseChange()),
        changeLanguage: (language) => dispatch(LanguageSwitcherRedux.changeLanguage(language)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);



// WEBPACK FOOTER //
// ./src/containers/Sidebar/Sidebar.tsx